import { ViewStream } from "spyne";
import { UtilTraits } from "traits/util-traits";

import TmplBlHeading2 from "components/pages/templates/blog/bl-heading-2.tmpl.html";
import TmplBlHeading3 from "components/pages/templates/blog/bl-heading-3.tmpl.html";
import TmplBlProse   from "components/pages/templates/blog/bl-prose.tmpl.html";
import TmplBlQuote   from "components/pages/templates/blog/bl-quote.tmpl.html";
import TmplBlList    from "components/pages/templates/blog/bl-list.tmpl.html";
import TmplBlFigure  from "components/pages/templates/blog/bl-figure.tmpl.html";
import TmplBlPrompt  from "components/pages/templates/blog/bl-prompt.tmpl.html";

// Renders one bl* content block of a blog article — the blog counterpart
// of PageDocsItemBlock's cl* vocabulary.
export class PageBlogArticleBlock extends ViewStream {
  constructor(props = {}) {
    props.template = PageBlogArticleBlock.getBlockTemplate(props.data);
    props.class = `blog-item-block blog-item-block-${props.data.blockType} ${props.data.classVal ?? ""}`;

    if (props.data.blockType === "blHeading") {
      const { headingId, text } = props.data;
      if (headingId === undefined || headingId === "") {
        props.data.headingId = UtilTraits.util$ToKebabCase(
          String(text).replace(/<[^>]+>/g, ""),
        );
      }
    }

    super(props);
  }

  static getBlockTemplate(data = {}) {
    const { blockType, level } = data;

    if (blockType === "blHeading") {
      // Per-level templates: DomElementTemplate can't emit dynamic tag
      // names, and real h2/h3 tags are required by the anchor-link feature.
      return Number(level) === 2 ? TmplBlHeading2 : TmplBlHeading3;
    }

    const tmplHash = {
      blProse:  TmplBlProse,
      blQuote:  TmplBlQuote,
      blList:   TmplBlList,
      blFigure: TmplBlFigure,
      blPrompt: TmplBlPrompt,
    };

    return tmplHash[blockType];
  }
}
